/* eslint no-undef: 0 */
import factoryLogger from '../../logger/index.js'
import PageMappersFactory from '../../page/Mappers/factory.js'
import PageServicesFactory from '../../page/Services/factory.js'
import {SearchErrorsFactory} from '../../search/Errors/factory.js'
import {SearchMappersFactory} from '../../search/Mappers/factory.js'
import {SearchServicesFactory} from '../../search/Services/factory.js'
import {SearchValueObjectsFactory} from '../../search/ValueObjects/factory.js'
import UserServicesFactory from '../../user/Services/factory.js'
import AdsErrorsFactory from '../Errors/factory.js'
import AdsMappersFactory from '../Mappers/factory.js'
import AdsRepositoriesFactory from '../Repositories/factory.js'
import AdsServicesFactory from '../Services/factory.js'
import AdsValueObjectsFactory from '../ValueObjects/factory.js'
import {GetModelDetailRelevantAdsRequestValueObject} from '../ValueObjects/GetModelDetailRelevantAdsRequestValueObject.js'
import GetAdDetailsAdsUseCase from './GetAdDetailsAdsUseCase.js'
import GetAdsFromLastSearchUseCase from './GetAdsFromLastSearchUseCase.js'
import GetAlertSearchAdsUseCase from './GetAlertSearchAdsUseCase.js'
import GetFinancingDataAdsUseCase from './GetFinancingDataAdsUseCase.js'
import {GetLastDetailsViewedAdsUseCase} from './GetLastDetailsViewedAdsUseCase.js'
import GetLastSearchesAdsUseCase from './GetLastSearchesAdsUseCase.js'
import GetLoginUrlForReservationAdsUseCase from './GetLoginUrlForReservationAdsUseCase.js'
import GetLoginUrlWithLeadPhoneCallUseCase from './GetLoginUrlWithLeadPhoneCallUseCase.js'
import {GetModelDetailRelevantAdsUseCase} from './GetModelDetailRelevantAdsUseCase.js'
import {GetNavigationLinksAdsUseCase} from './GetNavigationLinksAdsUseCase.js'
import {GetRecommendedAdsUseCase} from './GetRecommendedAdsUseCase.js'
import GetRelatedAdsUseCase from './GetRelatedAdsUseCase.js'
import {GetRelatedSubscriptionAdsUseCase} from './GetRelatedSubscriptionAdsUseCase.js'
import GetSearchPaginationUrlAdsUseCase from './GetSearchPaginationUrlAdsUseCase.js'
import GetSearchResultsAdsUseCase from './GetSearchResultsAdsUseCase.js'
import {GetSearchStatsAdsUseCase} from './GetSearchStatsAdsUseCase.js'
import GetSearchUpdateAdsUseCase from './GetSearchUpdateAdsUseCase.js'
import GetSearchUrlAdsUseCase from './GetSearchUrlAdsUseCase.js'
import {GetSubscriptionCarouselAdsUseCase} from './GetSubscriptionCarouselAdsUseCase.js'
import {GetSubscriptionCommitmentOptionsAdsUseCase} from './GetSubscriptionCommitmentOptionsAdsUseCase.js'
import GetTotalResultsAdsUseCase from './GetTotalResultsAdsUseCase.js'
import ReportAdsUseCase from './ReportAdsUseCase.js'
import SaveLastAdsSearchUseCase from './SaveLastAdsSearchUseCase.js'
import {SaveLastDetailViewedAdsUseCase} from './SaveLastDetailViewedAdsUseCase.js'
import {SaveNavigationDataAdsUseCase} from './SaveNavigationDataAdsUseCase.js'
import {SendComplaintAdsUseCase} from './SendComplaintAdsUseCase.js'

export default class AdsUseCasesFactory {
  static sendComplaintAdsUseCase = ({config}) =>
    new SendComplaintAdsUseCase({
      config,
      sendComplaintAdsRequestFactory: AdsValueObjectsFactory.sendComplaintAdsRequestValueObject,
      reportAdsRequestFactory: AdsValueObjectsFactory.reportAdsRequest,
      repository: AdsRepositoriesFactory.httpAdsRepository({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetAdDetailsAdsUseCase}
   * @property {GetAdDetailsAdsService} getAdDetailsAdsService
   */
  static getAdDetailsAdsUseCase = ({config}) =>
    new GetAdDetailsAdsUseCase({
      config,
      log: factoryLogger({prefix: 'GetAdDetailsAdsUseCase'}),
      getAdDetailsAdsService: AdsServicesFactory.getAdDetailsAdsService({
        config
      })
    })

  static getFinancingDataAdsUseCase = ({config, logger}) => {
    return new GetFinancingDataAdsUseCase({
      config,
      logger,
      service: AdsServicesFactory.getFinancingDataAdsService({config})
    })
  }

  static getSearchUpdateAdsUseCase = () => new GetSearchUpdateAdsUseCase()

  /**
   * @method
   * @return {GetAdsFromLastSearchUseCase}
   * @property {LocalStorageAdsRepository} repository
   * @property {Function} log
   * @property {GetHomeAdsService} service
   */
  static getAdsFromLastSearchUseCase = ({config}) =>
    new GetAdsFromLastSearchUseCase({
      config,
      repository:
        typeof localStorage !== 'undefined'
          ? AdsRepositoriesFactory.localStorageAdsRepository({config})
          : AdsRepositoriesFactory.emptyAdsRepository({config}),
      log: factoryLogger({prefix: 'GetAdsFromLastSearchUseCase'}),
      service: AdsServicesFactory.getHomeAdsService({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   */
  static getLastSearchesAdsUseCase = ({config}) =>
    new GetLastSearchesAdsUseCase({
      repository:
        typeof localStorage !== 'undefined'
          ? AdsRepositoriesFactory.localStorageAdsRepository({config})
          : AdsRepositoriesFactory.emptyAdsRepository({config})
    })

  static saveLastAdsSearchUseCase = ({config}) =>
    new SaveLastAdsSearchUseCase({
      repository:
        typeof localStorage !== 'undefined'
          ? AdsRepositoriesFactory.localStorageAdsRepository({config})
          : AdsRepositoriesFactory.emptyAdsRepository({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetRelatedAdsUseCase}
   * @property {GetRelatedAdsService} service
   */
  static getRelatedAdsUseCase = ({config}) =>
    new GetRelatedAdsUseCase({
      config,
      service: AdsServicesFactory.getRelatedAdsService({config}),
      requestValueObjectMapper: AdsMappersFactory.relatedAdsRequestValueObjectMapper({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetRelatedSubscriptionAdsUseCase}
   * @property {GetRelatedAdsService} service
   */
  static getRelatedSubscriptionAdsUseCase = ({config}) =>
    new GetRelatedSubscriptionAdsUseCase({
      config,
      service: AdsServicesFactory.getRelatedSubscriptionAdsService({config}),
      requestValueObjectMapper: AdsMappersFactory.relatedSubscriptionAdsRequestValueObjectMapper({
        config
      })
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {ReportAdsUseCase}
   */
  static reportAdsUseCase = ({config}) =>
    new ReportAdsUseCase({
      config,
      repository: AdsRepositoriesFactory.httpAdsRepository({config}),
      requestValueObject: AdsValueObjectsFactory.reportAdsRequest
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetSearchUrlAdsUseCase}
   */
  static getSearchUrlAdsUseCase = ({config}) =>
    new GetSearchUrlAdsUseCase({
      config,
      getUrlSearchService: SearchServicesFactory.getUrlSearchService({
        config
      })
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetSearchPaginationUrlAdsUseCase}
   */
  static getSearchPaginationUrlAdsUseCase = ({config}) =>
    new GetSearchPaginationUrlAdsUseCase({
      config,
      searchRequestValueObjectFactory: SearchValueObjectsFactory.searchRequestValueObject,
      getSearchPaginationUrlAdsService: AdsServicesFactory.getSearchPaginationUrlAdsService({config})
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {getSearchResultsAdsUseCase}
   */
  static getSearchResultsAdsUseCase = ({config}) =>
    new GetSearchResultsAdsUseCase({
      config,
      service: AdsServicesFactory.getSearchResultsAdsService({
        config
      })
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {getTotalResultsAdsUseCase}
   */
  static getTotalResultsAdsUseCase = ({config}) =>
    new GetTotalResultsAdsUseCase({
      config,
      service: AdsServicesFactory.getSearchResultsAdsService({
        config
      })
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetSubscriptionCarouselAdsUseCase}
   */
  static getSubscriptionCarouselAdsUseCase = ({config}) =>
    new GetSubscriptionCarouselAdsUseCase({
      config,
      fromAdsListValueObjectToSubscriptionCarouselAdsListValueObjectMapper:
        AdsMappersFactory.fromAdsListValueObjectToSubscriptionCarouselAdsListValueObjectMapper({config}),
      fromSubscriptionCarouselSearchRequestVOToSearchRequestVOMapper:
        SearchMappersFactory.fromSubscriptionCarouselSearchRequestVOToSearchRequestVOMapper({config}),
      fromSubscriptionCarouselSearchRequestVOToSubscriptionSearchRequestVOMapper:
        SearchMappersFactory.fromSubscriptionCarouselSearchRequestVOToSubscriptionSearchRequestVOMapper({config}),
      getSubscriptionSearchResultsAdsErrorFactory: SearchErrorsFactory.getSubscriptionSearchResultsAdsError,
      getSubscriptionSearchResultsAdsService: AdsServicesFactory.getSubscriptionSearchResultsAdsService({config}),
      searchRequestValueObjectFactory: SearchValueObjectsFactory.searchRequestValueObject
    })

  static getSubscriptionCommitmentOptionsAdsUseCase = ({config}) =>
    new GetSubscriptionCommitmentOptionsAdsUseCase({
      config,
      getSubscriptionCommitmentOptionsAdsService: AdsServicesFactory.getSubscriptionCommitmentOptionsAdsService({
        config
      })
    })

  // Experiment abtest8_web_newvehicle_call_logged_in
  static getLoginUrlWithLeadPhoneCallUseCase = ({config}) =>
    new GetLoginUrlWithLeadPhoneCallUseCase({
      config,
      getCurrentUserService: UserServicesFactory.getCurrentUserService({
        config
      }),
      getCurrentUrlService: PageServicesFactory.getCurrentUrlService({config}),
      getLoginUrlWithQueryParamsService: PageServicesFactory.getLoginUrlWithQueryParamsService({config})
    })

  static getAlertSearchAdsUseCase = ({config}) =>
    new GetAlertSearchAdsUseCase({
      config,
      getAlertSearchAdsService: AdsServicesFactory.getAlertSearchAdsService({
        config
      })
    })

  static getNavigationLinksAdsUseCase = ({config}) =>
    new GetNavigationLinksAdsUseCase({
      config,
      getNavigationLinksSearchService: SearchServicesFactory.getNavigationLinksSearchService({
        config
      }),
      navigationLinksRequestValueObjectFactory: SearchValueObjectsFactory.navigationLinksRequestValueObject
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {GetModelDetailRelevantAdsUseCase}
   */
  static getModelDetailRelevantAdsUseCase = ({config}) => {
    return new GetModelDetailRelevantAdsUseCase({
      config,
      httpAdsRepository: AdsRepositoriesFactory.httpAdsRepository({config}),
      getModelDetailRelevantAdsRequestVO: GetModelDetailRelevantAdsRequestValueObject.create,
      motosNotImplementedError: AdsErrorsFactory.motosNotImplementedError
    })
  }

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @param {SearchValueObjectsFactory} deps.navigationDataRequestValueObjectFactory
   * @param {Service} deps.saveNavigationDataAdsService
   * @return {SaveNavigationDataAdsService}
   */
  static saveNavigationDataAdsUseCase = ({config}) =>
    new SaveNavigationDataAdsUseCase({
      config,
      fromPlaceholderUrlToNextPageUrl: PageMappersFactory.fromPlaceholderUrlToNextPageUrl(),
      fromPlaceholderUrlToPreviousPageUrl: PageMappersFactory.fromPlaceholderUrlToPreviousPageUrl(),
      navigationDataRequestValueObjectFactory: SearchValueObjectsFactory.navigationDataRequestValueObject,
      saveNavigationDataAdsService: AdsServicesFactory.saveNavigationDataAdsService({
        config
      })
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   * @return {SaveLastDetailViewedAdsUseCase}
   */
  static saveLastDetailViewedAdsUseCase = ({config}) =>
    new SaveLastDetailViewedAdsUseCase({
      config,
      localStorageRepository: AdsRepositoriesFactory.localStorageAdsRepository({
        config
      })
    })

  /**
   * @method
   * @param {Object} deps
   * @param {Config} deps.config
   */
  static getLastDetailsViewedAdsUseCase = ({config}) =>
    new GetLastDetailsViewedAdsUseCase({
      localStorageRepository: AdsRepositoriesFactory.localStorageAdsRepository({
        config
      })
    })

  static getSearchStatsAdsUseCase = ({config}) =>
    new GetSearchStatsAdsUseCase({
      repository: AdsRepositoriesFactory.httpAdsRepository({config}),
      fromSearchParamsToStatsRequestVOMapper: AdsMappersFactory.fromSearchParamsToStatsRequestVOMapper({config})
    })

  static getRecommendedAdsUseCase = ({config}) =>
    new GetRecommendedAdsUseCase({
      httpAdsRepository: AdsRepositoriesFactory.httpAdsRepository({config})
    })

  static getLoginUrlForReservationAdsUseCase = ({config}) =>
    new GetLoginUrlForReservationAdsUseCase({
      config,
      getLoginUrlWithQueryParamsService: PageServicesFactory.getLoginUrlWithQueryParamsService({config})
    })
}
